<template>
  <div class="col-24">
    <div class="d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0">
            <strong v-text="$ml.get('managers')">Gestores</strong>
          </h2>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3">
        <p class="pl-3 mb-3" v-text="$ml.get('manageProgram')">
          Defina quem irá gerenciar o seu novo programa.
        </p>

        <div class="card card-body ml-3 p-0 d-flex w-100">
          <table class="mb-2">
            <thead>
              <tr>
                <th class="col-11 text-truncate">E-mail</th>
                <th
                  class="col-9 pl-0 text-truncate"
                  v-text="$ml.get('permission')"
                >
                  Permissão
                </th>
                <th
                  class="col-3 pl-0 text-truncate"
                  v-text="$ml.get('freeAccess')"
                >
                  Acesso liberado
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="loading" class="loading">
                <div class="c-loader m-3"></div>
              </tr>
              <div v-if="!loading">
                <tr
                  v-if="!listCompany_members.length"
                  class="d-flex align-items-center justify-content-center"
                >
                  <h6 class="my-3" v-text="$ml.get('noUserAvailable')">
                    Nenhum usuário disponível
                  </h6>
                </tr>
                <div
                  v-for="(item, index) in listCompany_members"
                  :key="index + 'role'"
                >
                  <tr v-if="item.status == 'active' && item.role == 'owner'">
                    <td class="col-11">
                      <strong v-text="item.email"></strong>
                    </td>
                    <td
                      class="col-9 pl-0 text-muted"
                      v-text="$ml.get('primaryEmail')"
                    >
                      E-mail principal
                    </td>
                    <td class="col-3 pl-0">
                      <VueCustomTooltip :label="$ml.get('awaitingAcceptance')">
                        <svg width="16" height="16" class="mb-1">
                          <image
                            xlink:href="../../../assets/icons/check.svg"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </td>
                  </tr>
                </div>
                <div
                  v-for="item in listCompany_members"
                  :key="item._id + 'members'"
                >
                  <tr v-if="item.status === 'active' && item.role != 'owner'">
                    <td class="col-11">
                      <strong v-text="item.email"></strong>
                    </td>
                    <td
                      class="col-9 pl-0 text-muted text-capitalize"
                      v-text="$ml.get(item.role)"
                    ></td>
                    <td class="col-2 pl-0">
                      <label class="switch mb-0">
                        <input
                          v-model="item.join_program"
                          type="checkbox"
                          checked
                          @click="addProgram(item._id)"
                        />
                        <span class="slider round"></span>
                      </label>
                    </td>
                  </tr>
                </div>
              </div>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-5"></span>
      </div>
    </div>
  </div>
</template>
<script>
import CompanyService from "../../../services/company.service";

export default {
  name: "userActive",
  props: ["number", "selectedMembers", "managers"],
  data() {
    return {
      listCompany_members: [],
      loading: true,
      selectedUsers: [],
    };
  },
  mounted() {},
  methods: {
    addProgram(id) {
      let filterList = this.listCompany_members.map((it) => {
        if (it._id === id) {
          it.join_program = !it.join_program;
        }
        return it;
      });
      this.listCompany_members = filterList;

      this.selectedUsers = this.listCompany_members?.filter(
        (it) => it?.join_program === true
      );
      this.selectedMembers(this.selectedUsers);
    },

    formartObj(data) {
      return data.map((i) => ({ ...i, join_program: false }));
    },

    changeMembers() {
      this.loading = true;

      CompanyService.getMembers().then(
        (response) => {
          this.loading = false;
          this.listCompany_members = this.formartObj(
            response.data.company_members
          );
          // let filterManagers = this.managers.map((it) => it._id);
          let filterManagers = [];
          // let listFinalManagers = this.listCompany_members.filter((it) => filterManagers.includes(it._id));

          this.listCompany_members = this.listCompany_members.map((it) => {
            if (filterManagers.includes(it._id)) {
              it.join_program = !it.join_program;
            }
            return it;
          });

          if (["owner", "administrator"].includes(this.user.role)) {
            for (let index = 0; index < this.listCompany_members.length; index++) {
              const element = this.listCompany_members[index];
              
              if(element.role == 'owner' || element.email == this.user.email){
                this.addProgram(element._id)
              }
              
            }
          }

        },
        () => {
          this.loading = false;
        }
      );
    },
  },
  created() {
    this.changeMembers();
    this.user = this.$store.getters["getUser"];
  },
};
</script>
